import { useController, useFormContext } from "react-hook-form";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import PropTypes from "prop-types";
import dayjs from "dayjs";

const FormTimePicker = ({ name, label, ...otherProps }) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: null,
  });

  const picker_value =
    field.value == null
      ? null
      : dayjs.isDayjs(field.value)
        ? field.value
        : dayjs(field.value);

  return (
    <TimePicker
      {...field}
      value={picker_value}
      label={label}
      onChange={(newValue) => {
        field.onChange(newValue ?? null);
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          error: !!error,
          helperText: error?.message,
        },
      }}
      {...otherProps}
    />
  );
};

FormTimePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FormTimePicker;
